export function getLanguageLabel(l) {
  if (!l) return '';
  return l.name ?? l.title ?? l.label ?? l.code ?? l.language_name ?? l.locale ?? (l.id != null ? `Language ${l.id}` : '');
}
